import { gql } from '@apollo/client';

export const getRubros = gql`
query getRubros{
    rubros (tipo:$tipoBuscador)
    @rest(type: "Rubro[]", path: "/{args.tipo}/rubrosvigentes"){
        codigo
        descripcion
    }
}`